{
  "version": 1,
  "asset_id": "ca1f4095-bf00-4bb6-acc7-6f0fb8c97bd1",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/ca1f4095-bf00-4bb6-acc7-6f0fb8c97bd1/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1320w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/ca1f4095-bf00-4bb6-acc7-6f0fb8c97bd1/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1320w.webp",
  "original_filename": "lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1320w.webp",
  "size": 78848,
  "content_type": "image/webp",
  "created_at": "2026-08-27T15:20:50Z"
}
